import LanguageSettings from 'pages/SettingsPage/General/LanguageSettings/LanguageSettings';

export default LanguageSettings;
